<template>
    <div>
        <fieldset class="forms__fieldset">
            <legend hidden>{{ lang('reservations::reservables.title') }}</legend>

            <Field
                v-model="modelValue.parent_id"
                :field="fields.parent_id"
                dusk="form-parent_id"
                :options="props.reservables"
                required
            />

            <Field v-model="modelValue.name" :field="fields.name" dusk="form-name" required />

            <Field v-model="modelValue.is_active" :field="fields.is_active" dusk="form-is_active" />

            <Field
                v-if="domains"
                v-model="modelValue.domain"
                :options="props.domains"
                :field="{
                    adminComponent: 'AdminSelect',
                    type: 'select',
                    name: 'Doména',
                }"
            />
        </fieldset>
    </div>
</template>

<script setup lang="ts">
import { Reservable } from '@src/Reservations/Pages/types';

const modelValue = defineModel({
    type: Object as () => Reservable,
});

interface Props {
    reservables?: Reservable[];
    domains?: any[];
    fields?: any;
}

const props = withDefaults(defineProps<Props>(), {
    reservables: () => [],
    domains: () => [],
    fields: () => ({}),
});
</script>
